import http from "./http";
import { wOrgIdMiddleware } from "../utils/commonUtils";
import { CREATED, OK } from "../utils/constant";

const Icd10Service = {
  getIcdList: async (query = {}) => {
    const queryString = new URLSearchParams(query).toString();
    try {
      const response = await http.GET(`icd10?${queryString}`);
      if (response.code === 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching Icd-10:", error);
      // throw error;
    }
  },
  //Save ICD
  saveIcd: async (data) => {
    try {
      const response = await http.POST(`icd10`, data);
      if (
        (response.code === OK || response.code === CREATED) &&
        response.data
      ) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.error("Error fetching Icd-10:", error);
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },

  //Delete ICD
  deleteIcd: async (id) => {
    try {
      const response = await http.DELETE(`icd10/${id}`);
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error("Error fetching Icd-10:", error);
      throw error;
    }
  },
  getIcdById: async (id) => {
    try {
      const response = await http.GET(`icd10/${id}`);
      if (response.code === OK) {
        return response.data;
      }
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
  updateIcdById: async (id, data) => {
    try {
      const response = await http.PUT(`icd10/${id}`, data);
      if (response.code === OK) {
        return response.data;
      }
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }

      // throw error;
    }
  },
};

export default Icd10Service;
